import { render, staticRenderFns } from "./shopStoreGoods.vue?vue&type=template&id=32ec2cf4&"
import script from "./shopStoreGoods.vue?vue&type=script&lang=js&"
export * from "./shopStoreGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports